{
  "adobeExperienceCloudNoOrgsSelect": "Seleziona un altro account organizzazione",
  "appSwitcherLinkOutIconLabel": "Si apre in una nuova finestra",
  "feedback button default": "Feedback",
  "help": "Aiuto",
  "launchsidebar": "Avvia barra laterale",
  "more actions": "Altre azioni",
  "searchButton": "Ricerca",
  "solutionSwitcher": "Passa a un’altra soluzione",
  "solutionSwitcherList": "Elenco applicazioni",
  "solutionSwitcherPopover": "Popover elenco applicazioni"
}
